/** Entrada dos DTOs de plantão (CONTRACT.md). Ausente = comportamento atual (`doctorId` decide). */
export enum CoverageMode {
  DOCTOR = 'DOCTOR',
  UNIDENTIFIED = 'UNIDENTIFIED',
  OPEN = 'OPEN'
}

export interface CoverageInput {
  coverage?: CoverageMode
  /** Obrigatório quando `coverage === UNIDENTIFIED`. */
  coverageResponsibleId?: number
  /** Até 500 caracteres. */
  coverageNote?: string
}

export interface ListCoverageResponsiblesParams {
  includeInactive?: boolean
}

export interface CreateCoverageResponsibleRequest {
  name: string
}

export interface UpdateCoverageResponsibleRequest {
  name?: string
  isActive?: boolean
}
